import React from 'react';
import { motion } from 'framer-motion';
import type { Stats } from '../types';

interface StatsCardsProps {
    stats: Stats;
}

type VariantType = 'default' | 'success' | 'danger';

export const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
    const cards = [
        {
            label: 'Всего сайтов',
            value: stats.total,
            hint: 'под наблюдением',
            variant: 'default' as VariantType
        },
        {
            label: 'Работают',
            value: stats.working,
            hint: 'сейчас онлайн',
            variant: 'success' as VariantType
        },
        {
            label: 'Проблемы',
            value: stats.problems,
            hint: 'требуют внимания',
            variant: (stats.problems > 0 ? 'danger' : 'default') as VariantType
        }
    ];

    const valueColors: Record<VariantType, string> = {
        default: 'text-[var(--text)]',
        success: 'text-[var(--status-up)]',
        danger: 'text-[var(--status-down)]'
    };

    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 px-[18px] pb-3.5">
            {cards.map((card, index) => (
                <motion.div
                    key={card.label}
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                    whileHover={{ y: -2, boxShadow: 'var(--shadow)' }}
                    className="bg-[var(--bg-elevated)] border border-[var(--border)] rounded-xl p-3.5 transition-all hover:border-[var(--border-strong)]"
                >
                    <div className="text-[10px] font-medium text-[var(--text-muted)] uppercase tracking-[0.06em] mb-2">
                        {card.label}
                    </div>
                    <div className={`font-mono text-[20px] font-medium tracking-[-0.5px] leading-none ${valueColors[card.variant]}`}>
                        {card.value}
                    </div>
                    <div className="text-[10px] text-[var(--text-muted)] mt-1.5">
                        {card.hint}
                    </div>
                </motion.div>
            ))}
        </div>
    );
};